import { render, staticRenderFns } from "./FaIcon.vue?vue&type=template&id=0d1cdfb8&"
import script from "./FaIcon.vue?vue&type=script&lang=ts&"
export * from "./FaIcon.vue?vue&type=script&lang=ts&"
import style0 from "./FaIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {VIcon})
